import React from 'react';
import PropTypes from 'prop-types';
import {
  TitleText,
  TitleLogo,
  ShopifyHero,
  ShopifyCollections,
  RichText,
  ListStaff,
  ListArticles,
  ListProjects,
  ListLogosClient,
  ListLogosAny,
  ListColors,
  ListAssets,
  ListImages,
  ListSteps,
  ListBlocks,
  Iframe,
  HeroVideo,
  HeroTestimonial,
  HeroStats,
  HeroReviews,
  HeroProjects,
  HeroProfile,
  FAQquestions,
  FAQanswers,
} from '../slices';
import { Container } from './Layout';

function themer(x) {
  const scale_spacing =
    x.primary &&
    x.primary.scale_module_spacing &&
    x.primary.scale_module_spacing.toLowerCase();
  const scale_text =
    x.primary &&
    x.primary.scale_module_text &&
    x.primary.scale_module_text.toLowerCase();
  const theme_dark = x.primary && x.primary.theme_color_dark;
  const theme_light = x.primary && x.primary.theme_color_light;
  const theme_name =
    x.primary && x.primary.theme_module && x.primary.theme_module.toLowerCase();

  return {
    spaceScale: scale_spacing,
    textScale: scale_text,
    color_dark: theme_dark,
    color_light: theme_light,
    theme: theme_name,
  };
}

export const SliceZone = ({ allSlices }) => {
  const slice = !allSlices
    ? null
    : allSlices.map((s, index) => {
        switch (s.slice_type) {
          case 'title_text':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <TitleText input={s} />
              </Container>
            );
          case 'title_logo':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <TitleLogo input={s} />
              </Container>
            );
          case 'text':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <RichText input={s} />
              </Container>
            );
          case 'hero_reviews':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <HeroReviews input={s} />
              </Container>
            );
          case 'hero_stats':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <HeroStats input={s} />
              </Container>
            );
          case 'hero_video':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <HeroVideo input={s} />
              </Container>
            );
          case 'hero_projects':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <HeroProjects input={s} />
              </Container>
            );
          case 'hero_profile':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <HeroProfile input={s} />
              </Container>
            );
          case 'hero_testimonial':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <HeroTestimonial input={s} />
              </Container>
            );

          case 'shopify_hero':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <ShopifyHero input={s} />
              </Container>
            );
          case 'shopify_collections':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <ShopifyCollections input={s} />
              </Container>
            );
          case 'list-articles':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <ListArticles input={s} />
              </Container>
            );
          case 'list_projects':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <ListProjects input={s} />
              </Container>
            );
          case 'list_assets':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <ListAssets input={s} />
              </Container>
            );
          case 'list_colors':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <ListColors input={s} />
              </Container>
            );
          case 'list_logos_clients':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <ListLogosClient input={s} />
              </Container>
            );
          case 'list_logos_any':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <ListLogosAny input={s} />
              </Container>
            );
          case 'list_faq':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <FAQquestions input={s} />;
                <FAQanswers input={s} />
              </Container>
            );
          case 'list_staff':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <ListStaff input={s} />
              </Container>
            );
          case 'list_images':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <ListImages input={s} />
              </Container>
            );
          case 'list_blocks':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <ListBlocks input={s} />
              </Container>
            );
          case 'list_steps':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <ListSteps input={s} />
              </Container>
            );

          case 'iframe':
            return (
              <Container key={s.id} {...themer(s)} hasBackground>
                <Iframe input={s} />
              </Container>
            );
          default:
            return (
              <h1 style={{ color: 'magenta' }} key={s.id + '-' + index}>
                Oops, <span style={{ color: 'yellow' }}>{s.slice_type}</span> is
                not included
                {console.warn(`Error: ${s.slice_type} is not included`)}
              </h1>
            );
        }
      });
  console.log();
  return <Container>{slice}</Container>;
};

SliceZone.propTypes = {
  allSlices: PropTypes.array.isRequired,
};

export default SliceZone;
